function NotificationCtrl($state, $stateParams, $rootScope, toaster, AppSettings, NotificationService, CommonService, $scope) {
  'ngInject'
  const vm = this;
  $rootScope.organizationNameView = false;

  $rootScope.$on("UpdateNotification", function(event, notification){
    vm.updateNotificatioFromWebSocket(notification);
  });

  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.loading = false;

  vm.init = function() {
    //to hide the organization name
    vm.url = `/notifications.json?page=${vm.pageNumber}&size=${vm.size}`,
    vm.loading = true;
    NotificationService.getNotifications(vm.url, function(response){
      vm.loading = false;
      if(response.status == 200) {
        vm.notificationResponse = response.data;
        vm.currentPage = vm.notificationResponse.pagination.current_page;
        vm.totalPages = vm.notificationResponse.pagination.total_pages;
        vm.notifications = vm.notificationResponse.notifications;
      }
    });
    $('[data-toggle="tooltip"]').tooltip();
    $(".tooltip-test").tooltip({container:'body'});
  }

  vm.updateNotificatioFromWebSocket = function(notification){
    vm.init();
  }

   vm.paginate = function (param) {
    vm.url = vm.notificationResponse.links[param];
     if(vm.url) {
       var arr = vm.url.split('?');
       vm.pageNumber = CommonService.getParameterByName('page', vm.url);
       vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
       $state.go('user.notification', {pageNumber: vm.pageNumber, size: vm.size});
     }
  };

  vm.markAsRead = function(id){
    NotificationService.markAsRead(id,function(response){
      $rootScope.unseen_notification_count = $rootScope.unseen_notification_count - 1;
      if($rootScope.unseen_notification_count == 0){
        $(".all_noti").addClass('hidden');
      }
      let nt = vm.notifications.find(function(d){
       return d.id == id;
      });
       nt['seen_at'] = new Date();
       nt['is_seen?'] = true;
    })
  };
  vm.markAllAsRead = function(){
    NotificationService.markAsRead(undefined,function(response){
      $rootScope.unseen_notification_count = 0;
      $(".all_noti").addClass('hidden');
      vm.markAsRead = response.data;
      vm.notifications.forEach(function(d){
       d['seen_at'] = new Date();
       d['is_seen?'] = true;
      });

    })
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.notificationResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    $state.go('user.notification', {pageNumber: vm.pageNumber, size: vm.size});
  };

  vm.getCreatedAgo = function(date){
    return moment(date).fromNow();
  };

  vm.getIcons = function(type){
      // return type;
        switch (type) {
            case 'success':
                return 'fa fa-check text-success';
                break;
            case 'error':
                return 'fa fa-exclamation-triangle text-danger';
                break;
            case 'warning':
                return 'fa fa-exclamation-circle text-warning';
                break;
            case 'info':
                return 'fa fa-info-circle text-info';
                break;
    }
  };
}

export default{
  name: 'NotificationCtrl',
  fn: NotificationCtrl
}

